export const extensionRoutes = [  {
    path: 'extensions/cms',
    loadChildren: () => import('./extensions/content-cms/routes'),
  },
  {
    path: 'extensions/shipping',
    loadChildren: () => import('./extensions/custom-shipping/routes'),
  },
  {
    path: 'extensions/newsletter',
    loadChildren: () => import('./extensions/newsletter/routes'),
  },
  {
    path: 'extensions/steuern',
    loadChildren: () => import('./extensions/tax-overview/routes'),
  }];
